import clsx from 'clsx';
import PropTypes from 'prop-types';

/**
 * Skeleton Loading Component
 * 
 * Displays a pulsing gray placeholder for content while loading.
 */
const Skeleton = ({ width, height, className, variant = 'text' }) => {
  const style = {
    width: width,
    height: height,
  };

  const baseClasses = 'skeleton-pulse';
  const variantClasses = {
    text: 'skeleton-text',
    circle: 'skeleton-circle',
    rect: 'skeleton-rect',
  };

  return (
    <div 
      className={clsx(baseClasses, variantClasses[variant], className)} 
      style={style}
      aria-hidden="true"
    />
  );
};

Skeleton.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  variant: PropTypes.oneOf(['text', 'circle', 'rect']),
};

export default Skeleton;
